import { render, staticRenderFns } from "./FirstBuy.vue?vue&type=template&id=b4cf7e64&scoped=true&"
import script from "./FirstBuy.vue?vue&type=script&lang=js&"
export * from "./FirstBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cf7e64",
  null
  
)

export default component.exports